export default __webpack_public_path__ + "scene3_2_bgb1574f.png";